import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-t border-primary/10 bg-background py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-74" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-75" data-mp="9t1pfcgekne6">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-primary bg-surface p-8 shadow-2xl shadow-black/40 sm:p-12" data-id="element-76" data-mp="euh8iyz0sjtx">
          <span className="inline-flex rounded-full border border-primary bg-background p-4 text-accent" data-id="element-77" data-mp="sn6ux4ignqrk">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-78" data-mp="xls07ickl0mv" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-4xl font-bold tracking-tight text-foreground" data-id="element-79" data-mp="12gxjsaii237s">
            7-Day Guarantee
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-80" data-mp="25s708e6i5769">
            Study the technical content this week. If it doesn't enhance your professional capability,{' '}
            <span className="font-extrabold text-accent" data-id="element-81" data-mp="1vthhykap1kph">we refund 100% of your money. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}